const data = (collection, keyword, filterDate, filterStatus) => {
  const dateStr =
    filterDate == null || filterDate == "" || typeof filterDate == "string"
      ? ""
      : filterDate.format("MM/DD/YYYY");

  return (
    collection &&
    Object.values(collection).filter((item) => {
      let available = false;
      if (
        (item.attributes.invoice_number
          .toLowerCase()
          .includes(keyword.toLowerCase()) ||
          item.attributes.enterprise
            .toLowerCase()
            .includes(keyword.toLowerCase())) &&
        item.attributes.invoice_date_formatted
          .toLowerCase()
          .includes(dateStr.toLowerCase()) &&
        item.attributes.status.includes(filterStatus ? filterStatus.value : "")
      )
        available = true;

      return available;
    })
  );
};

export default data;
